import EditCategory from './EditCategory'

export default EditCategory
